/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIPlanningEnum } from './APIPlanningEnum';
import {
    APIPlanningEnumFromJSON,
    APIPlanningEnumFromJSONTyped,
    APIPlanningEnumToJSON,
} from './APIPlanningEnum';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedRichContactRequest
 */
export interface APIPatchedRichContactRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIPatchedRichContactRequest
     */
    addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedRichContactRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedRichContactRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedRichContactRequest
     */
    mobile?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedRichContactRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedRichContactRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedRichContactRequest
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedRichContactRequest
     */
    comment?: string;
    /**
     * 
     * @type {APIPlanningEnum}
     * @memberof APIPatchedRichContactRequest
     */
    preferredContactMethod?: APIPlanningEnum | null;
}



/**
 * Check if a given object implements the APIPatchedRichContactRequest interface.
 */
export function instanceOfAPIPatchedRichContactRequest(value: object): value is APIPatchedRichContactRequest {
    return true;
}

export function APIPatchedRichContactRequestFromJSON(json: any): APIPatchedRichContactRequest {
    return APIPatchedRichContactRequestFromJSONTyped(json, false);
}

export function APIPatchedRichContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedRichContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'addresses': json['addresses'] == null ? undefined : json['addresses'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'language': json['language'] == null ? undefined : json['language'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'preferredContactMethod': json['preferred_contact_method'] == null ? undefined : APIPlanningEnumFromJSON(json['preferred_contact_method']),
    };
}

export function APIPatchedRichContactRequestToJSON(value?: APIPatchedRichContactRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'addresses': value['addresses'],
        'email': value['email'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'language': value['language'],
        'comment': value['comment'],
        'preferred_contact_method': APIPlanningEnumToJSON(value['preferredContactMethod']),
    };
}

